import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import CustomStore from 'devextreme/data/custom_store';
import { FormGroup, FormControl } from '@angular/forms';
import { DxDataGridComponent } from 'devextreme-angular';
import { ProjectService } from 'src/app/services/project.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { DxTreeViewComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { MapInformationService } from 'src/app/services/map-information.service';
import { Component, OnInit, Output, EventEmitter, ViewChild, Input, SimpleChanges, OnChanges } from '@angular/core';

type AOA = any[][];
declare var $: any;
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from 'src/app/services/utility.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { ReportService } from 'src/app/services/reports.service';
import { PartsService } from 'src/app/services/parts.service';
import { project } from 'src/app/pages/project-management/project-labor-projection/project-labor-projection.component';
@Component({
  selector: 'app-schedule-values',
  templateUrl: './schedule-values.component.html',
  styleUrls: ['./schedule-values.component.scss']
})

export class ScheduleValuesComponent implements OnInit, OnChanges {

  @ViewChild('gridObjectInformation', { static: false }) gridObjectInformation: DxDataGridComponent;
  @ViewChild('gridImportTemplate', { static: false }) gridImportTemplate: DxDataGridComponent;
  @ViewChild('gridChangeOrder', { static: false }) gridChangeOrder: DxDataGridComponent;
  @ViewChild("newPartSelect", { static: false }) newPartSelect: DxSelectBoxComponent;
  @ViewChild('ScheduleGrid1', { static: false }) ScheduleGrid1: DxDataGridComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: DxDataGridComponent;
  @ViewChild('ScheduleGrid', { static: false }) ScheduleGrid: DxDataGridComponent;
  @ViewChild("gridfile", { static: false }) gridfile: DxDataGridComponent;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @Input() parentProjectId: number;
  @Input() VieneDe: any;
  @Input() serviceID: any;
  // @Input() SalesTaxID: any;

  // @ViewChild("gridfile", { static: false })
  // gridfile: DxDataGridComponent;

  public dataSchedule;
  formatCurrency2: { type: string; currency: any; precision: number; };
  ChangeOrder: any;
  plusApplicationButton: { icon: string; type: string; onClick: () => void; };
  idTemplateSelected: number;
  saveEstiateButton: { icon: string; type: string; hint: string; class: string; onClick: () => void; };
  expandTax: { icon: string; type: string; hint: string; class: string; onClick: () => void; };

  @Input('infoschedule')
  set infoschedule(infoschedule: any) {
    this.dataSchedule = infoschedule;
  }
  @Input('SalesTaxID')
  set SalesTaxID(SalesTaxID: any) {
    this.taxSelected = SalesTaxID;
    console.log("🚀 ~ file: schedule-values.component.ts:52 ~ ScheduleValuesComponent ~ setSalesTaxID ~ this.taxSelected:", this.taxSelected)
  }
  @Output() onsubmit = new EventEmitter<any>();
  @Output() getGridBillingDetail = new EventEmitter<any>();


  formSchedule: FormGroup;
  billingcategory: any = [];
  partsProduct: any;
  settings: any = {};
  deleteSelectedId: any;
  billingCategorySelected: any;
  partDetails: any;
  formatCurrency: any;
  taxes: any;
  taxSelected: any;
  auto: any;

  //Popups
  popupAddItem = false;
  showpopupRequestMaterials = false;
  cancelButton: any;
  saveNewButton: any;
  saveButton: any;
  showpopupDeleteItem: boolean = false;
  popupEditMultiple: boolean = false;
  disableEditMultiple = true;
  rowSelectedMultiple = [];
  saveButtonEditMultiple: any;
  cancelButtonEditMultiple: any;
  product = ''
  taxamountValue: any;
  taxFactor: any
  taxFactorTemporal: any
  taxTrue: boolean = false
  disabledTaxt: boolean = true
  importFrom: any[] = [
    {
      name: "Estimate",
      id: 0
    },
    {
      name: "Spread Sheet",
      id: 1
    },
    {
      name: "Change Order",
      id: 2
    },
    {
      name: "From Template",
      id: 3
    }
  ]

  openPopupEstimated: boolean = false
  estimate: any[] = []
  scheduleOfValuesDatasource = [];
  idEstimate: any = ""
  ImporFrom: any = ""
  seletedRowEdit = false;
  popupImportFromExcel: boolean = false
  openPopupChangeOrder: boolean = false
  openFullScreen: boolean = false
  openImportfromtemplate: boolean = false

  valueDocument: any[] = [];

  toooltipVisible: boolean = false;

  markup: number = 0;

  popupTitle = '';
  originalUnitPrice: any = 0;
  popupNewAppNotes: boolean = false

  modelEdit = {
    applicationName: '',
    labelName: '',
    enable: true,
    testid: '',
    pointid: '',
    unitid: '',
    wiringid: '',
    objectreffid: '',
    partid: '',
    readingRange: null,
    minvalue: 0,
    maxvalue: 0,
    id: 0
  };

  partstr: string;
  drawingTemplates: any[] = [];
  objectTypeSelect: any[] = [];
  wiringSelect: any[] = [];
  unitSelect: any[] = [];
  objReferenceSelect: any[] = [];
  testSelect: any[] = [];
  partSelect: any[] = [];
  pointTypeSelect: any[] = []
  partselected: any[] = []

  popupKit: boolean = false;
  kitPartNumber: string = '';
  kitDescription: string = '';
  kitDescriptionLength: number = 0;

  popupFonts: boolean = false;
  items: any = [
    "undo", "redo", "separator",
    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },
    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",
    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },
    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];

  constructor(
    private route: Router,
    private toast: ToastService,
    private translate: TranslateService,
    private appconfig: AppConfigService,
    private utilityService: UtilityService,
    private loadingService: LoadingService,
    private projectService: ProjectService,
    private deltaService: DeltaworldService,
    public MapInformationService: MapInformationService,
    private estimateService: EstimateService,
    private reportService: ReportService,
    private partService: PartsService,
  ) {
    this.settings.dateFormat = this.appconfig.dateFormat;
    this.settings.moneyFormat = this.appconfig.moneyFormat;
    let moneyTableFormat = this.settings.moneyFormat;
    if (this.appconfig.moneyFormat == '$') { moneyTableFormat = 'USD' }

    // this.taxSelected = this.SalesTaxID
    // console.log("🚀 ~ file: schedule-values.component.ts:132 ~ ScheduleValuesComponent ~ this.taxSelected:", this.taxSelected)
    this.formatCurrency = { style: 'currency', currency: moneyTableFormat }
    this.formatCurrency2 = { type: 'currency', currency: moneyTableFormat, precision: 3 }

    this.plusApplicationButton = {
      icon: "plus",
      type: "button",
      onClick: () => {

        this.getPointType();
        this.getObjectTypes()
        this.getWiringdiagram()
        this.getTest()
        this.getUnit()
        this.getPartsApplication()
        this.getReferences()

        this.popupNewAppNotes = true;
      },
    };


    this.saveEstiateButton = {
      icon: "fas fa-save",
      type: "button",
      hint: "Save Estimate",
      class: "btn-green1 mr-1 d-none d-sm-block",
      onClick: () => {
        this.SaveEstimate()

      },
    };

    this.expandTax = {
      icon: "fas fa-expand",
      type: "button",
      hint: "Expand",
      class: "btn-green1 mr-1 d-none d-sm-block",
      onClick: () => {
        this.openFullScreen = true

      },
    };


  }

  getPointType() {
    this.utilityService.GetPointType().subscribe(result => {
      this.pointTypeSelect = result;
    })
  }

  getPartsApplication() {
    this.utilityService.GetParts().subscribe(result => {
      this.partSelect = result;
    });
  }

  getTemplateDrawing() {
    this.utilityService.Get_EstDrawingListTemplateCE().subscribe(result => {
      this.drawingTemplates = result;
    });
  }

  getObjectTypes() {
    this.utilityService.GetObjectTypes().subscribe(result => {
      this.objectTypeSelect = result;
    });
  }

  getWiringdiagram() {
    this.utilityService.GetWiringdiagram().subscribe(result => {
      this.wiringSelect = result;
    });
  }

  getTest() {
    this.utilityService.GetTest().subscribe(result => {
      this.testSelect = result;
    });
  }

  getUnit() {
    this.utilityService.GetUnits().subscribe(result => {
      this.unitSelect = result;
    });
  }


  getParts() {
    this.utilityService.GetParts().subscribe(result => {
      this.partselected = result;
    });
  }

  getReferences() {
    this.deltaService.GetEstimateObjectReferences().subscribe(result => {
      this.objReferenceSelect = result;
    })
  }


  toggleDefault() {
    this.toooltipVisible = !this.toooltipVisible;
  }

  ngOnInit() {
    this.onReorderInputs = this.onReorderInputs.bind(this);

    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupAddItem = false;
        this.partsProduct = []
        this.markup = 0
        this.newPartSelect.placeholder = "Select"
        this.initForm()
      },
    };

    this.saveButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.markup = 0
        this.saveNewItem();
      },
    };

    // this.getBillingCategory();
    this.projectService.GetTaxes().subscribe(result => {
      console.log(result)
      let dataTaxes = []
      if (result.length > 0) {
        result.forEach(element => {
          if (element.TAX != undefined) {
            dataTaxes.push(element)
          }
        });
      }
      this.taxes = dataTaxes;
      console.log("🚀 ~ file: schedule-values.component.ts:188 ~ ScheduleValuesComponent ~ this.projectService.GetTaxes ~ this.taxes:", this.taxes)
    })
    console.log('Schedule Values ', this.dataSchedule)

    this.getTemplate()

    this.getEstimatebyProject()

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('AAAAAAAAAAAAAAAAAAAAA ', changes)
    if (changes.VieneDe != undefined) {
      if (changes.VieneDe.firstChange == false) {
        this.ngOnInit()
      }
    }

    if (changes.parentProjectId != undefined) {
      if (changes.parentProjectId.currentValue != undefined) {
        this.projectService.GetBillingSchedule(changes.parentProjectId.currentValue).subscribe(result => {
          console.log('Data Schedule ', result);
          this.dataSchedule = result.map((val, id) => {
            val.TAX == true ? val.TAXCHECK = true : val.TAXCHECK = false;
            val.SHOWINBILL == true ? val.SHOWINBILLCHECK = true : val.SHOWINBILLCHECK = false;
            val.TAX == true ? val.TAXYesOrNo = "Yes" : val.TAXYesOrNo = "No";
            val.SHOWINBILL == true ? val.SHOWINBILLYesOrNo = "Yes" : val.SHOWINBILLYesOrNo = "No";
            if (val.DESCRIPTION != undefined) {
              val.DESCRIPTION = val.DESCRIPTION.replace(/<[^>]+>/g, '')
            }
            val.number != undefined ? val.number = val.number.toFixed(2) : '';
            if (val.QTY != undefined && val.PRODUCTSLSPRICE != undefined) {
              val.ValTotalPrice = val.QTY * val.PRODUCTSLSPRICE
              val.ValTotalPrice.toFixed(2)
            }
            return val;
          })
        })
      }
    }
  }

  mdAddItem() {
    this.initForm();
    this.getAllParts();
    this.getBillingCategory();
    this.popupAddItem = true;
    this.popupTitle = this.translate.instant('ModalEditProjecNOpenItem.title');
  }

  getBillingCategory() {
    if (this.billingcategory.length == 0) {
      this.projectService.GetBillingCategorys().subscribe(result => {
        this.billingcategory = result;
      })
    }
  }

  getAllParts() {
    let mythis = this;

    this.partsProduct = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == undefined || loadOptions.searchValue == "") {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.projectService.GetAllParts(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  onFocusOut(e) {
    console.log('EVENTO ', e);
    let newValue = this.formSchedule.get('productslsprice');
  }

  updateParts(e) {

    if (e.selectedItem !== null && e.selectedItem !== undefined) {
      console.log(e.selectedItem)
      this.formSchedule.get('partnumber').setValue(e.selectedItem.ID);
      this.projectService.GetProjectPartDetail2(e.selectedItem.ID, this.parentProjectId).subscribe(result => {
        console.log(result)
        this.formSchedule.get('description').setValue(result[0].PartDescription);
        this.formSchedule.get('costammount').setValue(result[0].PartCost);
        this.formSchedule.get('productslspriceOriginal').setValue(result[0].ProductPrice);
        this.formSchedule.get('productslsprice').setValue(result[0].ProductPrice);
        this.formSchedule.get('productnumber').setValue(result[0].ProductNumber);

        // result[0].Tax_Factor = 0.07;
        console.log(result[0].ProductPrice)
        this.originalUnitPrice = result[0].ProductPrice;

        const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo = Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto = Math.abs(segundo) - Math.abs(tercero)

        if (this.taxTrue) {
          if (result[0].Tax_Factor == 0) {
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
          }
        } else {
          if (result[0].Tax_Factor == 0) {
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
            this.taxamountValue = undefined
            this.taxFactor = undefined
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = undefined
            this.taxFactor = undefined
          }
        }
        this.disabledTaxt = false
        this.changeBillingAmount();
        this.calculateUnitPrice();
      })
    }
  }

  setTax(data) {
    // console.log(data)
    this.taxTrue = data.value
    if (data.value) {
      const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const segundo = Math.abs(primero) * Math.abs(this.taxFactorTemporal)

      const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const cuarto = Math.abs(segundo) - Math.abs(tercero)

      if (this.taxFactorTemporal == 0) {
        this.taxamountValue = 0
        this.taxFactorTemporal = 0
        this.taxFactor = 0
      } else {
        this.taxamountValue = cuarto
        this.taxFactor = this.taxFactorTemporal
        let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)
        this.formSchedule.get('billingamount').setValue(billingFinal);
      }
    } else {
      let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }
  }

  changeBillingAmount() {
    const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    const segundo = Math.abs(primero * this.taxFactor)

    const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    const cuarto = Math.abs(segundo) - Math.abs(tercero)

    if (this.taxFactorTemporal == 0) {
      this.taxamountValue = 0
      this.taxFactorTemporal = 0
      this.taxFactor = 0
    } else {
      this.taxamountValue = Math.abs(cuarto)
    }

    let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)

    if (this.taxTrue) {
      this.formSchedule.get('billingamount').setValue(billingFinal);
    } else {
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }

  }

  //change color header grid
  onCellPrepared(e) {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "rgb(242, 242, 242)";
      e.cellElement.style.color = "rgb(0, 0, 0)";
    }
  }

  duplicate(data) {
    this.projectService.DuplicateBillingSchedule(data.ID).subscribe(result => {
      this.toast.success(this.translate.instant('msgItemDuplSucc'));
      this.onsubmit.emit();
    })
  }

  selectForDelete(data) {
    this.showpopupDeleteItem = true;
    this.deleteSelectedId = data.ID;
  }

  deleteItem(id) {
    this.projectService.DelteBillingSchedule(id).subscribe(result => {
      this.toast.success(this.translate.instant('msgItemDuplSucc'));
      this.showpopupDeleteItem = false;
      this.onsubmit.emit();
    })
  }

  selectionChanged() {
    console.log("aqui")
    this.rowSelectedMultiple = this.ScheduleGrid.instance.getSelectedRowsData();
    if (this.rowSelectedMultiple.length >= 1) {
      this.seletedRowEdit = true;
    } else {
      this.seletedRowEdit = false;
    }
  }

  initForm() {
    this.formSchedule = new FormGroup({
      partnumber: new FormControl('', []),
      qty: new FormControl(1, []),
      description: new FormControl('', []),
      productdiscount: new FormControl(0, []),
      costammount: new FormControl(0, []),
      productslsprice: new FormControl(0, []),
      billingamount: new FormControl('', []),
      sort: new FormControl(0, []),
      area: new FormControl('', []),
      billingcategory: new FormControl('', []),
      tax: new FormControl('', []),
      showinbill: new FormControl('', []),
      overridenotes: new FormControl('', []),
      notes: new FormControl('', []),
      productnumber: new FormControl('', []),
      projectid: new FormControl(this.parentProjectId, []),
      id: new FormControl(0, []),
      productslspriceOriginal: new FormControl(0, []),
      addmarkup: new FormControl(0, []),
    });
    this.product = '';
  }

  saveNewItem() {
    let form = this.formSchedule.value;
    form.tax == true ? form.tax = 1 : form.tax = 0;
    form.showinbill == true ? form.showinbill = 1 : form.showinbill = 0;
    if (this.VieneDe == "editSWO") {
      form.serviceid = this.serviceID
    }
    console.log(form)
    form.addmarkup = form.addmarkup * 100

    this.projectService.InsertUpdateSchedule(form).subscribe(result => {
      console.log(result)
      this.toast.success(this.translate.instant('msgQuoInfoUpdSucc'));
      this.popupAddItem = false;
      this.taxamountValue = 0
      this.taxFactor = 0
      this.newPartSelect.placeholder = "Select"
      this.partsProduct = []
      this.onsubmit.emit();
    })
  }

  edit(data) {
    console.log(data)
    this.projectService.GetProjectPartDetail2(data.PARTID, this.parentProjectId).subscribe(result => {
      this.originalUnitPrice = result[0].ProductPrice
      console.log(data)
      this.formSchedule = new FormGroup({
        partnumber: new FormControl(data.PARTID, []),
        qty: new FormControl(data.QTY, []),
        description: new FormControl(data.DESCRIPTION, []),
        productdiscount: new FormControl(data.PRODUCTDISCOUNT, []),
        costammount: new FormControl(data.COSTAMMOUNT, []),
        productslsprice: new FormControl(data.PRODUCTSLSPRICE, []),
        billingamount: new FormControl(data.BILLINGAMMOUN, []),
        sort: new FormControl(data.SORT, []),
        area: new FormControl(data.AREA, []),
        billingcategory: new FormControl(data.BILLINGCATEGORY, []),
        tax: new FormControl(data.TAX, []),
        showinbill: new FormControl(data.SHOWINBILL, []),
        overridenotes: new FormControl(data.OVERRIDENOTES, []),
        notes: new FormControl(data.NOTES, []),
        productnumber: new FormControl(data.PRODUCTNUMBER, []),
        projectid: new FormControl(this.parentProjectId, []),
        id: new FormControl(data.ID, []),
        productslspriceOriginal: new FormControl(0, []),
        addmarkup: new FormControl(data.ADDMARKUP != undefined ? data.ADDMARKUP / 100 : 0, []),
      });

      // this.markup = data.ADDMARKUP

      // this.originalUnitPrice = data.PRODUCTSLSPRICE
      console.log(data)
      setTimeout(() => {
        if (this.newPartSelect != undefined) {
          // this.newPartSelect.placeholder = data.DESCRIPTION
          this.newPartSelect.placeholder = data.PARTNUMBER
        }
      }, 1000);
      console.log(result)
      this.disabledTaxt = false
      // result[0].Tax_Factor = 0.07;
      if (data.TAX) {
        this.taxTrue = true

        const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo = Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto = Math.abs(segundo) - Math.abs(tercero)

        if (this.taxTrue) {
          if (result[0].Tax_Factor == 0) {
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = cuarto
            this.taxFactor = result[0].Tax_Factor
          }
        } else {
          if (result[0].Tax_Factor == 0) {
            this.taxamountValue = 0
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = undefined
            this.taxFactor = undefined
          }
        }
        this.disabledTaxt = false
        this.changeBillingAmount();
      } else {
        this.taxTrue = false
        const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo = Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto = Math.abs(segundo) - Math.abs(tercero)

        if (result[0].Tax_Factor == 0) {
          this.taxamountValue = 0
          this.taxFactorTemporal = 0
          this.taxFactor = 0
        } else {
          this.taxFactorTemporal = result[0].Tax_Factor
          this.taxamountValue = cuarto
          this.taxFactor = result[0].Tax_Factor
        }
        this.changeBillingAmount();
      }
      // this.product = data.PARTNUMBER
      this.product = data.DESCRIPTION
      this.popupAddItem = true;
      this.popupTitle = this.translate.instant('ModalEditProjecNOpenEditItem.title');
      this.getBillingCategory();
      this.getAllParts();
    })
  }

  mdEditMultiple() {
    console.log('Original Data ', this.dataSchedule);
    this.rowSelectedMultiple = [];
    this.rowSelectedMultiple = this.ScheduleGrid.instance.getSelectedRowsData();
    console.log("🚀 ~ file: schedule-values.component.ts:516 ~ ScheduleValuesComponent ~ mdEditMultiple ~ this.rowSelectedMultipl", this.rowSelectedMultiple);

    this.cancelButtonEditMultiple = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupEditMultiple = false;
      },
    };

    this.saveButtonEditMultiple = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveEditMultiple();
      },
    };

    this.getBillingCategory();

    this.popupEditMultiple = true;
  }

  openModalDeleteMultiple: boolean = false

  mdDeleteMultiple() {
    this.openModalDeleteMultiple = true
  }

  DeleteMultiple() {
    let data = this.ScheduleGrid.instance.getSelectedRowsData();
    console.log(data)
    let contador = 0
    data.forEach(element => {
      this.projectService.DelteBillingSchedule(element.ID).subscribe(result => {
        contador++
        if (contador == data.length) {
          this.toast.warning("Items were removed successfully")
          this.openModalDeleteMultiple = false
          this.onsubmit.emit();
        }
      })
    })

  }

  saveEditMultiple() {
    console.log(this.rowSelectedMultiple)

    let ids = '';
    this.rowSelectedMultiple.forEach((key, i) => {
      if (key.OVERRIDENOTES != undefined) {
        if (key.OVERRIDENOTES.length > 50) {
          this.toast.warning("Override Notes can be max 50 characters long")
          return false
        }
      }
      ids = key.ID + ',' + ids;

      let valorFinal = 0
      let Calculartax = 0

      if (key.TAXCHECK) {
        Calculartax = (key.QTY * key.PRODUCTSLSPRICE) * key.TaxPercent
        valorFinal = (key.QTY * key.PRODUCTSLSPRICE) + Calculartax
      } else {
        valorFinal = key.QTY * key.PRODUCTSLSPRICE
      }
      let saveRow = {
        id: key.ID,
        projectid: this.parentProjectId,
        notes: key.NOTES,
        partnumber: key.PARTID,
        productnumber: key.PRODUCTNUMBER,
        qty: key.QTY,
        description: key.DESCRIPTION,
        costammount: key.COSTAMMOUNT,
        productslsprice: key.PRODUCTSLSPRICE,
        billingamount: valorFinal,
        sort: key.SORT,
        area: key.AREA,
        billingcategory: key.BILLINGCATEGORY,
        tax: key.TAXCHECK,
        showinbill: key.SHOWINBILLCHECK,
        overridenotes: key.OVERRIDENOTES,
      }

      saveRow.tax == true ? saveRow.tax = 1 : saveRow.tax = 0;
      saveRow.showinbill == true ? saveRow.showinbill = 1 : saveRow.showinbill = 0;
      if (this.VieneDe == "editSWO") {
        let serviceid = { serviceid: this.serviceID }
        Object.assign(saveRow, serviceid);
      }
      console.log(saveRow);

      this.projectService.InsertUpdateSchedule(saveRow).subscribe(result => {
        if (this.rowSelectedMultiple.length == i + 1) {
          // console.log('Guardado ',result);
          this.toast.success(this.translate.instant('msgQuoInfoUpdSucc'));
          this.onsubmit.emit();
          this.popupEditMultiple = false;
        }
      })
    })
  }

  // printReport(){
  //   this.route.navigate(['/reportviewer'], { queryParams: { reportname: "ProjectSOVandPart", reportparameters: "<projectid>"+this.parentProjectId+"</projectid>" } } );
  // }

  updateTaxes() {
    // console.log(this.taxSelected)
    this.projectService.UpdateProjectTax(this.parentProjectId, this.taxSelected).subscribe(result => {
      // console.log(result);
      this.toast.success(this.translate.instant('msgTaxUpdSucc'));
      this.updateBillingSchedule()
    })
  }

  dataFormatted = { headers: [], data: [] };
  openPopupImport(data) {
    console.log(data)
    if (data.value === 0) {
      this.ImporFrom = 0
      this.openPopupEstimated = true
      const datos = {
        method: "Get_Projectestimate",
        projectid: this.parentProjectId
      }
      // console.log(datos)
      this.MapInformationService.SaveInfoSites(datos)
        .subscribe(resp => {
          this.estimate = resp
          // console.log(resp)
        })
    } else if (data.value === 1) {
      this.ImporFrom = 1
      this.popupImportFromExcel = true
    } else if (data.value === "") {
      this.ImporFrom = ""
      this.openPopupEstimated = false
      this.popupImportFromExcel = false
      this.openPopupChangeOrder = false
    } else if (data.value === 2) {
      this.ImporFrom = 2
      this.openPopupChangeOrder = true

      const datos = {
        method: "Get_Project_ChangeOrderImportByID",
        projectid: this.parentProjectId
      }
      // console.log(datos)
      this.MapInformationService.SaveInfoSites(datos)
        .subscribe(resp => {
          this.ChangeOrder = resp
          // console.log(resp)
        })
    } else if (data.value === 3) {
      this.ImporFrom = 3
      this.openImportfromtemplate = true

      const datos = {
        method: "GetSOVTemplates",
      }
      // console.log(datos)
      this.MapInformationService.SaveInfoSites(datos)
        .subscribe(resp => {
          console.log(resp)
          this.dataTemplate = resp.map(x => {
            x.nameFinal = x.NAME + ' - ' + x.DESCRIPTION
            return x;
          })
          // console.log(resp)
        })
    }
  }

  dataTemplate: any[] = []

  CloseopenPopupImport() {
    // console.log("aqui")
    this.openPopupEstimated = false
    this.popupImportFromExcel = false
    this.idEstimate = ""
    this.scheduleOfValuesDatasource = []
    this.ImporFrom = ""
    this.onFileRemove()
    this.valueDocument = []
  }


  searchEstimate(data) {
    const datos = {
      'method': 'Get_EstimateScheduleOfValuesCE',
      'estimateid': data.value
    }
    this.idEstimate = data.value
    this.MapInformationService.SaveInfoSites(datos)
      .subscribe(resp => {
        console.log(resp)
        let id = 0;
        this.scheduleOfValuesDatasource = resp.map(x => {
          id++;
          x.ident = id;

          return x;
        })
        // for (let i = 0; i < 30; i++) {
        //   this.scheduleOfValuesDatasource.push(this.scheduleOfValuesDatasource[0])
        // }
      })
  }


  importEstimate() {
    console.log("aqui")
    const data = {
      method: "Insert_CreateSOVfroestimateCE",
      estimateid: this.idEstimate
    }
    // console.log(data)
    this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        console.log(resp)
        this.CloseopenPopupImport()
        this.updateBillingSchedule()
      })
  }

  updateBillingSchedule() {
    this.projectService.GetBillingSchedule(this.parentProjectId).subscribe(result => {
      this.dataSchedule = result.map((val, id) => {
        val.TAX == true ? val.TAXCHECK = true : val.TAXCHECK = false;
        val.TAX == true ? val.TAXYesOrNo = "Yes" : val.TAXYesOrNo = "No";
        val.SHOWINBILL == true ? val.SHOWINBILLYesOrNo = "Yes" : val.SHOWINBILLYesOrNo = "No";
        val.SHOWINBILL == true ? val.SHOWINBILLCHECK = true : val.SHOWINBILLCHECK = false;
        if (val.DESCRIPTION != undefined) {
          val.DESCRIPTION = val.DESCRIPTION.replace(/<[^>]+>/g, '')
        }
        val.number != undefined ? val.number = val.number.toFixed(2) : '';
        if (val.QTY != undefined && val.PRODUCTSLSPRICE != undefined) {
          val.ValTotalPrice = val.QTY * val.PRODUCTSLSPRICE
          val.ValTotalPrice.toFixed(2)
        }
        return val;
      })
      console.log('Data Schedule Grid ', this.dataSchedule);
    })
  }

  onFileRemove() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.valueDocument = []
    // this.popupImportFromExcel = false
  }

  fileData: any[][] = [];
  onFileAdd(obj: File) {
    if (obj[0] != undefined) {
      this.loadingService.isLoading.next(true);
      console.log('added', obj[0]);
      /* wire up file reader */
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        data = data.filter(x => x.length > 0);
        this.fileData = data;
        this.dataFormatted.headers = data[0];
        console.log(JSON.stringify(data[0]))
        let dataFormateada = this.arrayToJSONObject(data);
        let infoFinal = []
        if (dataFormateada.length != 0) {
          dataFormateada.forEach(element => {
            if (element.Quantity != undefined) {
              infoFinal.push(element)
            }
          })
          // this.dataFormatted.data = dataFormateada;
          this.dataFormatted.data = infoFinal;
          console.log(this.dataFormatted)
        }
        this.validateFile();
        // console.log('obj', this.dataFormatted.data.filter(x => !x.TAG && !x.QTY && !x.POINTTYPE && !x.POINTNUMBER && !x.PARTNUMBER && !x.APPNOTES));

        // console.log('obj', this.dataFormatted.data.filter(x =>  !x.TAG && !x.QTY && !x.POINTTYPE && !x.POINTNUMBER && !x.PARTNUMBER && !x.APPNOTES));
      };
      reader.readAsBinaryString(obj[0]);
      this.loadingService.isLoading.next(false);
    }
  }

  arrayToJSONObject(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  validateFile() {
    // this.dataFormatted.data.forEach(x => {
    //   this.estimateService.Get_EstimateAreaSystemDetailsImportCE(x.PARTNUMBER, x.APPNOTES, x.POINTTYPE).subscribe(result => {
    //     let obj = result[0];
    //     if (obj) {
    //       x.FlagApp_Note = obj.App_Note;
    //       x.FlagPart_Number = obj.Part_Number;
    //       x.FlagPoint_Type = obj.Point_Type;
    //     }
    //       console.log(result);
    //   });
    // });
  }

  async uploadFile() {
    // let data = this.gridfile.instance.getVisibleRows().map(x => x.data);
    let data = this.dataFormatted.data;
    let info: any;
    let contadorTaxt = 0
    let contadorCostPrice = 0
    console.log(data)
    data.forEach(element => {
      if (element.Taxable == 0 || element.Taxable == 1 || element.Taxable == "" || element.Taxable == undefined) {
      } else {
        this.toast.warning("The Taxable field must be 1 for yes and 0 for no")
        contadorTaxt++
      }

      // if (element.Show_in_Bill == 0 || element.Show_in_Bill == 1 || element.Show_in_Bill == "" || element.Show_in_Bill == undefined){
      // } else {
      //   this.toast.warning("The Show_in_Bill field must be 1 for yes and 0 for no")
      //   contadorTaxt++
      // }

      if (element.Cost === undefined || element.Cost === "" || element.Cost == null || element.Price === undefined || element.Price === "" || element.Price === null) {

        console.log(element.Cost)
        console.log(element.Quantity)
        console.log(element.Price)
        this.toast.warning("The quantity, cost and price fields cannot be empty (you can put 0 instead)")
        contadorCostPrice++
      }
      if (isNaN(element.Quantity) == true || isNaN(element.Cost) == true || isNaN(element.Price) == true) {
        this.toast.warning("The quantity, cost and price fields cannot have characters (you can put 0 instead)")
        contadorCostPrice++
      }
    })
    if (contadorCostPrice == 0) {
      for (const element of data) {
        // 1. Buscar part number
        const respPart = await this.MapInformationService.SaveInfoSites({
          method: 'Get_AccParts',
          partnamefilter: element.Product_Number
        }).toPromise();

        const partnumber = respPart && respPart.length > 0 ? respPart[0].ID : '';

        // 2. Armar objeto de inserción
        info = {
          partnumber,
          productnumber: partnumber,
          qty: parseInt(element.Quantity),
          description: element.Billing_Description,
          costammount: Number(element.Cost),
          productslsprice: Number(element.Price),
          billingamount: (element.Quantity * element.Price).toFixed(4),
          sort: element.Sort,
          area: element.Area,
          billingcategory: element.Category_ID,
          tax: element.Taxable == true ? 1 : 0,
          showinbill: 1,
          overridenotes: element.Override_Notes == undefined ? '' : element.Override_Notes,
          notes: '',
          projectid: this.parentProjectId,
          id: 0,
          method: 'Insert_ProjectPartDetailformSS',
          productmodel: element.Product_Number
        };

        if (this.VieneDe == 'editSWO') {
          info.serviceid = this.serviceID;
        }

        // 3. Insertar — si falla, detener
        try {
          await this.MapInformationService.SaveInfoSites(info).toPromise();
        } catch (error) {
          console.log(error);
          this.toast.warning('An error has occurred check the header and structure of the excel');
          return;
        }
      }

      // 4. Todos los elementos insertados correctamente
      this.toast.success('information successfully uploaded');
      this.onFileRemove();
      this.CloseopenPopupImport();
      this.onsubmit.emit();
    }
  }

  valueTaxDefault: boolean = false
  valueShowBillDefault: boolean = false




  updateBillingAmount(event) {
    console.log(event)
    // this.originalUnitPrice = event.value;

    const primero = this.formSchedule.get('qty').value * event.value;
    const segundo = Math.abs(primero * this.taxFactor)

    const tercero = this.formSchedule.get('qty').value * event.value;
    const cuarto = Math.abs(segundo) - Math.abs(tercero)

    if (this.taxFactorTemporal == 0) {
      this.taxamountValue = 0
      this.taxFactorTemporal = 0
      this.taxFactor = 0
    } else {
      this.taxamountValue = Math.abs(cuarto)
    }

    let billing = this.formSchedule.get('qty').value * event.value;
    let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)

    if (this.taxTrue) {
      this.formSchedule.get('billingamount').setValue(billingFinal);
    } else {
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }
  }

  infoMaterial: any[] = []
  showPopupMR: boolean = false
  openModalRequest() {
    this.MapInformationService.SaveInfoSites({ method: "Get_ProjectsovByIdforMR", projectid: this.parentProjectId })
      .subscribe(resp => {
        console.log(resp)
        this.showpopupRequestMaterials = true
        this.infoMaterial = resp
      })
  }

  saveRequestModal() {
    console.log("aqui")
    this.showPopupMR = true
  }

  saveRequest() {
    let data = this.gridObjectInformation.instance.getSelectedRowsData();
    if (data.length > 0) {
      console.log(data)
      let dataFinal = ""
      data.forEach(info => {
        if (dataFinal == "") {
          dataFinal = info.ID.toString()
        } else {
          dataFinal += "," + info.ID.toString()
        }
      })
      let datos: any = { method: "Save_EditProjectMaterialRequest", projectid: this.parentProjectId, detailid: dataFinal }
      // if(this.serviceID){
      //   datos.swoid = this.serviceID;
      //   console.log('Hay service id ', datos)
      // }else{
      //   console.log('No Hay serice ID ', datos);
      // }

      this.MapInformationService.SaveInfoSites(datos)
        .subscribe(resp => {
          this.toast.success("The Material Request information has been updated successfully")
          this.showpopupRequestMaterials = false
          this.showPopupMR = false
          this.updateBillingSchedule()
        })
    } else {
      this.toast.warning("You must select one or more records")
    }
  }

  updateShowInBill(obj) {
    console.log(this.rowSelectedMultiple)
    console.log(obj)
    if (obj.event != undefined) {
      this.rowSelectedMultiple = this.rowSelectedMultiple.map(x => {
        // x.PrefferedYesorNo = obj.value == true ? "Yes":"No";
        x.SHOWINBILL = obj.value;
        x.SHOWINBILLCHECK = obj.value;
        return x;
      })
    }
  }

  titleHeaderTemplateTax(obj) {
    console.log(this.rowSelectedMultiple)
    console.log(obj)
    if (obj.event != undefined) {
      this.rowSelectedMultiple = this.rowSelectedMultiple.map(x => {
        // x.PrefferedYesorNo = obj.value == true ? "Yes":"No";
        x.TAX = obj.value;
        x.TAXCHECK = obj.value;
        return x;
      })
    }
  }

  ImporChangeOrder() {
    let data = this.gridChangeOrder.instance.getSelectedRowsData()
    console.log(data)
    if (data.length > 0) {

      // esta forma es con un bucle
      let contador = 0
      data.forEach(x => {
        const dataFinal = {
          method: "Insert_CreateSOVfromchangeorder",
          projectid: this.parentProjectId,
          calctypid: 1,
          billingammount: x.AMMOUNT,
          // scopeofwork:x.ID,
          scopeofwork: x.NOTES,
        }
        this.MapInformationService.SaveInfoSites(dataFinal)
          .subscribe(resp => {
            contador++
            if (contador == data.length) {
              this.toast.success("Items imported successfully")
              this.closeChangeOrder()
            }
          })
      })
    } else {
      this.toast.warning("You must select at least an item to import")
    }
    console.log(data)
  }

  closeChangeOrder() {
    this.openPopupChangeOrder = false
    this.ImporFrom = ''
    this.gridChangeOrder.instance.deselectAll()
    this.updateBillingSchedule()
  }

  updateCheck(event, type, data) {
    console.log(data)
    console.log(event)
    let info = {}
    let value = event.value == true || event.value == "Yes" ? 1 : 0

    let id = data.data.ID

    if (type == 'tax') {
      info = {
        method: 'InsertUpdate_ProjectPartDetailGrid',
        id: id,
        showinbill: data.data.SHOWINBILLCHECK == true ? 1 : 0,
        tax: value,
        // billingamount: newTotalPriceWithTax,
      }
      // console.log(info)
    } if (type == 'showinbill') {
      info = {
        method: 'InsertUpdate_ProjectPartDetailGrid',
        id: id,
        showinbill: value,
        tax: data.data.TAXCHECK == true ? 1 : 0
      }
    }
    console.log(info)
    this.MapInformationService.SaveInfoSites(info).subscribe(resp => {
      console.log(resp)
      this.getGridBillingDetail.emit()
      console.log('eh??')
      this.toast.success(this.translate.instant('msgUpdSucc'))
      this.updateBillingSchedule()
    })
  }

  onToolbarPreparing(e) {
    console.log('Event ', e);

    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }

  onReorderInputs(e) {
    console.log('Reorder ', e);
    let visibleRows = e.component.getVisibleRows();

    let newArray = visibleRows.map(x => x.data);

    this.rowSelectedMultiple.splice(e.fromIndex, 1);
    this.rowSelectedMultiple.splice(e.toIndex, 0, e.itemData);
    console.log("🚀 ~ file: schedule-values.component.ts:1108 ~ ScheduleValuesComponent ~ onReorderInputs ~ rowSelectedMultiple", this.rowSelectedMultiple)

    console.log('New Array ', newArray);

    let newIndex = e.fromIndex < e.toIndex ? e.fromIndex : e.toIndex;

    for (let index = newIndex; index < this.rowSelectedMultiple.length; index++) {
      this.rowSelectedMultiple[index.SORT] = index + 1;
    }

    console.log('FINAL ', this.rowSelectedMultiple);
  }

  changeCategory(e, data) {
    console.log("🚀 ~ file: schedule-values.component.ts:1122 ~ ScheduleValuesComponent ~ changeCategory ~ data", data)
    console.log(e);
    console.log(this.billingcategory)
    console.log("🚀 ~ rowSelectedMultiple", this.rowSelectedMultiple);

    if (e.previousValue) {
      let index = this.rowSelectedMultiple.findIndex(x => x.ID == data.ID);
      let category = this.billingcategory.find(x => x.ID == e.value);
      if (category) {
        console.log(category);
        this.rowSelectedMultiple[index].Billingcategoryname = category.TODOCATEGORY;
      }
    }
  }

  calculateUnitPrice() {
    // let unitPrice = this.formSchedule.get('productslsprice').value;
    console.log(this.formSchedule.value)
    let unitPrice = this.originalUnitPrice;
    let calculatedMarkUp = this.formSchedule.value.addmarkup * 100;
    console.log(this.originalUnitPrice)
    console.log('Unit Price ', unitPrice, ' Mark Up ', calculatedMarkUp);

    let finalPrice = unitPrice * (1 + (calculatedMarkUp / 100));

    console.log('Final Price ', finalPrice);

    this.formSchedule.get('productslsprice').setValue(finalPrice);
  }

  templates: any[] = []
  templatesO: any[] = []
  templateSelected: any
  getTemplate() {
    this.MapInformationService.SaveInfoSites({ method: 'Get_ClientTemplateCE', modulename: "SalesQuote" })
      .subscribe(resp => {
        console.log(resp)
        this.templates = []
        this.templates = resp;
      })
  }

  PrintReport(data) {

    // if (this.templateSelected != undefined){
    console.log(data.itemData)
    let nameReport = ""
    console.log(this.templates)
    this.templates.forEach(x => {
      if (x.CLIENTNAME == data.itemData.CLIENTNAME) {
        nameReport = x.DESIGNERNAME
      }
    })
    console.log(nameReport)

    var mydisplayName = "EST_" + this.parentProjectId;

    this.route.navigate(['/reportviewer'], { queryParams: { displayName: mydisplayName, reportname: nameReport, reportparameters: "<projectid>" + this.parentProjectId + "</projectid>" } });
    // } else {
    //   this.toast.warning("You must select a template")
    // }

    // })

  }

  popupNewPart: boolean = false
  partDataSource: any
  newPartModal() {
    let mythis = this;
    this.partDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        loadOptions.searchValue = loadOptions.searchValue ? loadOptions.searchValue : 'par';
        return mythis.estimateService.Get_AccParts(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
    this.popupNewPart = true;
  }

  modelAddParts = {
    Id: 0,
    Unique: false,
    PartNumber: '',
    PointNumber: 0,
    PointType: 0,
    Tag: '',
    AppNoteId: 0,
    AppNote: '',
    Qty: 0,
    PartCost: 0,
    PartId: 0,
    Notes: '',
    systemid: 0
  };

  PartCreated(newPart) {
    this.partDataSource = []
    this.newPartSelect.instance.reset()

    console.log(newPart)

    this.modelAddParts.PartNumber = newPart.partnumber
    this.modelAddParts.PartId = newPart.idNewPart
    this.modelAddParts.PartCost = newPart.price
    this.newPartSelect.placeholder = newPart.partnumber + ' | ' + newPart.partdescription + '[' + newPart.price + ' ] '

    let mythis = this;
    this.partDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        loadOptions.searchValue = loadOptions.searchValue ? loadOptions.searchValue : 'par';
        return mythis.estimateService.Get_AccParts(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });


    this.formSchedule.get('partnumber').setValue(newPart.idNewPart);
    this.projectService.GetProjectPartDetail2(newPart.idNewPart, this.parentProjectId).subscribe(result => {
      console.log(result)
      this.formSchedule.get('description').setValue(result[0].PartDescription);
      this.formSchedule.get('costammount').setValue(result[0].PartCost);
      this.formSchedule.get('productslspriceOriginal').setValue(result[0].ProductPrice);
      this.formSchedule.get('productslsprice').setValue(result[0].ProductPrice);
      this.formSchedule.get('productnumber').setValue(result[0].ProductNumber);

      // result[0].Tax_Factor = 0.07;
      console.log(result[0].ProductPrice)
      this.originalUnitPrice = result[0].ProductPrice;

      const primero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const segundo = Math.abs(primero) * Math.abs(result[0].Tax_Factor)

      const tercero = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const cuarto = Math.abs(segundo) - Math.abs(tercero)

      if (this.taxTrue) {
        if (result[0].Tax_Factor == 0) {
          this.taxamountValue = 0
          this.taxFactorTemporal = 0
          this.taxFactor = 0
        } else {
          this.taxFactorTemporal = result[0].Tax_Factor
        }
      } else {
        if (result[0].Tax_Factor == 0) {
          this.taxamountValue = 0
          this.taxFactorTemporal = 0
          this.taxFactor = 0
          this.taxamountValue = undefined
          this.taxFactor = undefined
        } else {
          this.taxFactorTemporal = result[0].Tax_Factor
          this.taxamountValue = undefined
          this.taxFactor = undefined
        }
      }
      this.disabledTaxt = false
      this.changeBillingAmount();
      this.calculateUnitPrice();
    })



  }


  //   {
  //     "partnumber": 21738,
  //     "qty": 1,
  //     "description": null,
  //     "productdiscount": 0,
  //     "costammount": 25,
  //     "productslsprice": 0,
  //     "billingamount": 0,
  //     "sort": 0,
  //     "area": "",
  //     "billingcategory": "",
  //     "tax": 0,
  //     "showinbill": 0,
  //     "overridenotes": "",
  //     "notes": "",
  //     "productnumber": null,
  //     "projectid": "9051",
  //     "id": 0,
  //     "productslspriceOriginal": null,
  //     "addmarkup": 0,
  //     "method": "InsertUpdate_ProjectPartDetail"
  // }


  estimatesByProject: any[] = [];
  DetailProject: any[] = [];
  idEstimateSelected: any = 0

  getEstimatebyProject() {
    const datos = {
      method: "Get_Projectestimate",
      projectid: this.parentProjectId
    }
    // console.log(datos)
    this.MapInformationService.SaveInfoSites(datos)
      .subscribe(resp => {
        this.estimatesByProject = resp
        // this.idEstimateSelected = 2758
      })

    this.getEstimateDefault()

  }

  SaveEstimate() {
    console.log(this.idEstimateSelected)

    this.MapInformationService.SaveInfoSites({ method: "UpdateProjectEstimateid", projectid: this.parentProjectId, estimateid: this.idEstimateSelected })
      .subscribe(resp => {
        this.getEstimatebyProject()
        this.toast.success("Updated Successfully")
      })
  }

  getEstimateDefault() {
    this.MapInformationService.SaveInfoSites({ method: "GetProjectEstimateid", projectid: this.parentProjectId })
      .subscribe(x => {
        this.idEstimateSelected = x[0].ProjectEstId
      })
  }

  itemsCommandsActions = [
    { id: 1, name: 'Add New Item', icon: 'plus' },
    { id: 2, name: 'Edit Multiple', icon: 'edit' },
    { id: 3, name: 'Delete Multiple', icon: 'trash' },
    { id: 4, name: 'Create Kit', icon: 'box' }
  ]

  onItemsClickCommands(e) {
    switch (e.itemData.id) {
      case 1:
        this.mdAddItem()
        break;
      case 2:
        this.mdEditMultiple()
        break;
      case 3:
        this.mdDeleteMultiple()
        break;
      case 4:
        this.showModalKit()
        break;
    }
  }

  dataSelected: any[] = []
  kitType: any

  showModalKit() {
    this.dataSelected = this.ScheduleGrid.instance.getSelectedRowsData()
    if (this.dataSelected.length > 0) {
      this.popupKit = true;
      this.getType();
    } else {
      this.toast.warning("You must select at least one item to create a kit");
    }

  }

  parttype: any[] = []

  getType() {
    this.partService.GetPartType().subscribe(result => {
      console.log("🚀 ~ file: new-part.component.ts:93 ~ NewPartComponent ~ this.partService.GetPartType ~ result:", result)
      this.parttype = result;
    })
  }

  closeKitPopup() {
    this.popupKit = false;
    this.kitPartNumber = '';
    this.kitDescription = '';
    this.kitDescriptionLength = 0;
    this.kitType = '';
  }

  showPopupToDelete = false
  saveKit(save: any) {

    if (this.kitPartNumber == '' || this.kitDescription == '' || this.kitType == '') {
      this.toast.warning("You must fill in all fields to create a kit");
    } else {
      if (save == undefined) {
        this.showPopupToDelete = true;
      } else {

        const PARTIDs = this.dataSelected.map(item => item.PARTID).join(',');
        const quantities = this.dataSelected.map(item => item.QTY).join(',');
        const partdetailids = this.dataSelected.map(item => item.ID).join(',');

        console.log('Product Numbers:', PARTIDs);
        console.log('Quantities:', quantities);
        console.log('Kit Part Number:', this.kitPartNumber);
        console.log('Kit Description:', this.kitDescription);

        const dataFinal = {
          method: "CreatePartKit_FromParts",
          partids: PARTIDs,
          partqty: quantities,
          partnumber: this.kitPartNumber,
          partdescription: this.kitDescription,
          typeid: this.kitType,
          partdetailids: partdetailids,
        }

        this.MapInformationService.SaveInfoSites(dataFinal)
          .subscribe(resp => {
            console.log(resp)
            if (save == 2) {
              // aqui vas a guardar el kit y eliminar los items seleccionados
              this.MapInformationService.SaveInfoSites({ method: 'ReplacePartsForKit', partdetailids: partdetailids, kitid: resp[0].ID })
                .subscribe(resp => {
                  this.toast.success("Kit created successfully");
                  this.ScheduleGrid.instance.deselectAll();
                  this.closeKitPopup();
                  this.showPopupToDelete = false;
                  this.updateBillingSchedule();
                })
            } else {
              this.toast.success("Kit created successfully");
              this.ScheduleGrid.instance.deselectAll();
              this.closeKitPopup();
              this.updateBillingSchedule();
              this.showPopupToDelete = false;
            }
          })
      }
    }



  }

  popupTemplate: boolean = false
  templateName: string = ''
  shortDescription: string = ''
  ModalTemplate() {
    this.popupTemplate = true
  }

  CloseTemplate() {
    this.popupTemplate = false
    this.templateName = ''
    this.shortDescription = ''
  }

  createTemplate() {
    console.log(this.templateName)
    console.log(this.parentProjectId)

    console.log(this.shortDescription)

    this.MapInformationService.SaveInfoSites({ method: 'SaveProjectSOVAsTemplate', name: this.templateName, projectid: this.parentProjectId, description: this.shortDescription })
      .subscribe(resp => {
        this.CloseTemplate()
        this.toast.success("Template created successfully")
      })
  }

  saveImport() {
    console.log(this.idTemplateSelected)
    console.log(this.parentProjectId)
    this.MapInformationService.SaveInfoSites({ method: 'ImportProjectSOVFromTemplate', templateid: this.idTemplateSelected, newprojectid: this.parentProjectId })
      .subscribe(resp => {
        this.toast.success("Template imported successfully")
        this.closeImport()
      })
  }

  seachDetail(event) {
    console.log(event)
    const projectid = event.selectedItem.PROJECTID

    this.projectService.GetBillingSchedule(projectid).subscribe(result => {
      console.log('Data Schedule ', result);
      this.DetailProject = result.map((val, id) => {
        val.TAX == true ? val.TAXCHECK = true : val.TAXCHECK = false;
        val.SHOWINBILL == true ? val.SHOWINBILLCHECK = true : val.SHOWINBILLCHECK = false;
        val.TAX == true ? val.TAXYesOrNo = "Yes" : val.TAXYesOrNo = "No";
        val.SHOWINBILL == true ? val.SHOWINBILLYesOrNo = "Yes" : val.SHOWINBILLYesOrNo = "No";
        if (val.DESCRIPTION != undefined) {
          val.DESCRIPTION = val.DESCRIPTION.replace(/<[^>]+>/g, '')
        }
        val.number != undefined ? val.number = val.number.toFixed(2) : '';
        if (val.QTY != undefined && val.PRODUCTSLSPRICE != undefined) {
          val.ValTotalPrice = val.QTY * val.PRODUCTSLSPRICE
          val.ValTotalPrice.toFixed(2)
        }
        return val;
      })
    })

  }

  closeImport() {
    this.openImportfromtemplate = false
    this.updateBillingSchedule()
    this.idTemplateSelected = 0
    this.DetailProject = []
  }

  openModalTypeofExport: boolean = false
  optionExport: any = [{
    id: 1,
    name: "Standard Template"
  },
  {
    id: 2,
    name: "Customized Template"
  }
  ]

  exportQuote() {
    console.log('Export Quote 1');
    console.log(this.templates);
    this.openModalTypeofExport = true
  }

  showReports: any = 0 // 1 = true, 2 = false
  ReportSelected: any[] = []
  optionReport: any[] = []

  dataSelectInclude: any[] = [
    { id: 'cover-page', name: 'Including Report Cover Page' },
    // { id: 'cover-letter', name: 'Including Cover Letter' },
    { id: 'terms', name: 'Including Terms and Conditions' },
    { id: 'header', name: 'Including Header' },
    { id: 'exclusions', name: 'Including Exclusions' },
    { id: 'warranty', name: 'Including Warranty' },
    { id: 'price-summary', name: 'Including Price Summary' },
    { id: 'signature', name: 'Including Signature' },
    { id: "email-notes", name: 'Including Email Notes' },
    // { id: "catalog", name: 'Including Catalog' },

  ]

  dataIncludeSelected: any[] = []

  handleValueChange(event: any) {

    if (event.event != undefined) {
      if (event.value == 1) {
        this.showReports = 1
      } else {
        this.showReports = 2
      }
    }




    // if (event.value == 2) {
    //   this.showReports = true
    //   this.ReportSelected = []
    //   this.templateSelected = undefined
    //   this.dataIncludeSelected = []
    // } else {
    //   this.showReports = false
    //   this.ReportSelected = []
    //   this.templateSelected = undefined
    //   this.dataIncludeSelected = []
    // }
  }


  ReportCover: boolean = false

  exportFinal() {

    console.log(this.showReports)
    console.log(this.ReportSelected)
    console.log(this.dataIncludeSelected)


    if (this.showReports == 1 && this.templateSelected != undefined) {
      let nameReport = ""
      this.templates.forEach(x => {
        if (x.DESIGNERNAME == this.templateSelected) {
          nameReport = x.DESIGNERNAME
          console.log(x)
        }
      })
      var displayName = "EST_" + this.parentProjectId;
      console.log(displayName)
      console.log(this.parentProjectId)
      this.openModalTypeofExport = false
      this.route.navigate(['/reportviewer'], { queryParams: { displayName: displayName, reportname: nameReport.trim(), reportparameters: "<projectid>" + this.parentProjectId + "</projectid>" } });

    } else if (this.showReports == 2 && this.dataIncludeSelected.length > 0) {

      var displayName = "EST_" + this.parentProjectId;

      this.route.navigate(['/reportviewer'], {
        queryParams: {
          displayName: displayName, reportname: 'TemplateSWO2',
          reportparameters: "<projectid>" + this.parentProjectId + "</projectid>" +
            "<coverPage>" + (this.dataIncludeSelected.some(item => item === "cover-page") ? 1 : 0) + "</coverPage>" +
            "<coverLetter>" + (this.dataIncludeSelected.some(item => item === "cover-letter") ? 1 : 0) + "</coverLetter>" +
            "<terms>" + (this.dataIncludeSelected.some(item => item === "terms") ? 1 : 0) + "</terms>" +
            "<header>" + (this.dataIncludeSelected.some(item => item === "header") ? 1 : 0) + "</header>" +
            "<exclusions>" + (this.dataIncludeSelected.some(item => item === "exclusions") ? 1 : 0) + "</exclusions>" +
            "<warranty>" + (this.dataIncludeSelected.some(item => item === "warranty") ? 1 : 0) + "</warranty>" +
            "<price-summary>" + (this.dataIncludeSelected.some(item => item === "price-summary") ? 1 : 0) + "</price-summary>" +
            "<signature>" + (this.dataIncludeSelected.some(item => item === "signature") ? 1 : 0) + "</signature>" +
            "<email-notes>" + (this.dataIncludeSelected.some(item => item === "email-notes") ? 1 : 0) + "</email-notes>" +
            "<catalog>" + (this.dataIncludeSelected.some(item => item === "catalog") ? 1 : 0) + "</catalog>"
        }
      });

    } else {
      this.toast.warning("You must select a template or include data to export the report")
      return;
    }
  }

  onDescriptionClick(data) {
    console.log(data);
    this.route.navigateByUrl('/parts/editParts?numID=' + data.PARTID)
  }

  htmlContent: string = 'text to test fonts';

  // Opciones de botones para el toolbar
  undoButtonOptions = {
    icon: 'fas fa-undo',
    text: 'Undo',
    onClick: () => {
      console.log('Undo clicked');
      this.handleToolbarAction('undo');
    }
  };

  redoButtonOptions = {
    icon: 'fas fa-redo',
    text: 'Redo',
    onClick: () => {
      console.log('Redo clicked');
      this.handleToolbarAction('redo');
    }
  };

  boldButtonOptions = {
    icon: 'fas fa-bold',
    text: 'Bold',
    onClick: () => {
      console.log('Bold clicked');
      this.handleToolbarAction('bold');
    }
  };

  italicButtonOptions = {
    icon: 'fas fa-italic',
    text: 'Italic',
    onClick: () => {
      console.log('Italic clicked');
      this.handleToolbarAction('italic');
    }
  };

  underlineButtonOptions = {
    icon: 'fas fa-underline',
    text: 'Underline',
    onClick: () => {
      console.log('Underline clicked');
      this.handleToolbarAction('underline');
    }
  };

  strikeButtonOptions = {
    icon: 'fas fa-strikethrough',
    text: 'Strike',
    onClick: () => {
      console.log('Strike clicked');
      this.handleToolbarAction('strike');
    }
  };

  alignLeftButtonOptions = {
    icon: 'fas fa-align-left',
    text: 'Align Left',
    onClick: () => {
      console.log('Align Left clicked');
      this.handleToolbarAction('alignLeft');
    }
  };

  alignCenterButtonOptions = {
    icon: 'fas fa-align-center',
    text: 'Align Center',
    onClick: () => {
      console.log('Align Center clicked');
      this.handleToolbarAction('alignCenter');
    }
  };

  alignRightButtonOptions = {
    icon: 'fas fa-align-right',
    text: 'Align Right',
    onClick: () => {
      console.log('Align Right clicked');
      this.handleToolbarAction('alignRight');
    }
  };

  alignJustifyButtonOptions = {
    icon: 'fas fa-align-justify',
    text: 'Align Justify',
    onClick: () => {
      console.log('Align Justify clicked');
      this.handleToolbarAction('alignJustify');
    }
  };

  orderedListButtonOptions = {
    icon: 'fas fa-list-ol',
    text: 'Ordered List',
    onClick: () => {
      console.log('Ordered List clicked');
      this.handleToolbarAction('orderedList');
    }
  };

  bulletListButtonOptions = {
    icon: 'fas fa-list-ul',
    text: 'Bullet List',
    onClick: () => {
      console.log('Bullet List clicked');
      this.handleToolbarAction('bulletList');
    }
  };

  colorButtonOptions = {
    icon: 'fas fa-palette',
    text: 'Color',
    onClick: () => {
      console.log('Color clicked');
      this.handleToolbarAction('color');
    }
  };

  backgroundButtonOptions = {
    icon: 'fas fa-fill-drip',
    text: 'Background',
    onClick: () => {
      console.log('Background clicked');
      this.handleToolbarAction('background');
    }
  };

  linkButtonOptions = {
    icon: 'fas fa-link',
    text: 'Link',
    onClick: () => {
      console.log('Link clicked');
      this.handleToolbarAction('link');
    }
  };

  clearButtonOptions = {
    icon: 'fas fa-eraser',
    text: 'Clear',
    onClick: () => {
      console.log('Clear clicked');
      this.handleToolbarAction('clear');
    }
  };

  insertTableButtonOptions = {
    icon: 'fas fa-table',
    text: 'Insert Table',
    onClick: () => {
      console.log('Insert Table clicked');
      this.handleToolbarAction('insertTable');
    }
  };

  // Opciones para select boxes
  fontSelectBoxOptions = {
    items: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"],
    value: "Arial",
    onValueChanged: (e: any) => {
      console.log('Font changed:', e.value);
      this.handleToolbarAction('font', e.value);
    }
  };

  sizeSelectBoxOptions = {
    items: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"],
    value: "12pt",
    onValueChanged: (e: any) => {
      console.log('Size changed:', e.value);
      this.handleToolbarAction('size', e.value);
    }
  };

  headerSelectBoxOptions = {
    items: [
      { text: "Normal", value: false },
      { text: "Heading 1", value: 1 },
      { text: "Heading 2", value: 2 },
      { text: "Heading 3", value: 3 },
      { text: "Heading 4", value: 4 },
      { text: "Heading 5", value: 5 }
    ],
    displayExpr: "text",
    valueExpr: "value",
    value: false,
    onValueChanged: (e: any) => {
      console.log('Header changed:', e.value);
      this.handleToolbarAction('header', e.value);
    }
  };

  changeAllFonts() {
    this.popupFonts = true;
  }

  // Variable para almacenar las opciones del toolbar seleccionadas
  selectedToolbarOptions: any = {};

  handleToolbarAction(action: string, value?: any): void {
    console.log('Toolbar action:', action, 'Value:', value);

    // Almacenar la acción
    this.selectedToolbarOptions[action] = {
      action: action,
      value: value || true,
      timestamp: new Date()
    };

    console.log('Opciones del toolbar almacenadas:', this.selectedToolbarOptions);

    // Aquí puedes implementar la lógica específica para cada acción
    switch (action) {
      case 'bold':
        console.log('Aplicando negrita');
        break;
      case 'italic':
        console.log('Aplicando cursiva');
        break;
      case 'underline':
        console.log('Aplicando subrayado');
        break;
      case 'font':
        console.log('Cambiando fuente a:', value);
        break;
      case 'size':
        console.log('Cambiando tamaño a:', value);
        break;
      case 'color':
        console.log('Cambiando color');
        break;
      case 'background':
        console.log('Cambiando color de fondo');
        break;
      default:
        console.log('Acción del toolbar:', action);
    }
  }

  // Función para obtener las opciones seleccionadas
  getSelectedToolbarOptions(): any {
    return this.selectedToolbarOptions;
  }

  // Función para obtener una opción específica
  getToolbarOption(optionName: string): any {
    return this.selectedToolbarOptions[optionName];
  }

  // Función para limpiar las opciones almacenadas
  clearToolbarOptions(): void {
    this.selectedToolbarOptions = {};
    console.log('Opciones del toolbar limpiadas');
  }

  validateKitFields(): boolean {
    return !!(this.kitPartNumber &&
      this.kitDescription &&
      this.kitType &&
      this.kitDescription.length <= 500);
  }

  onKitDescriptionChange(event: any): void {
    this.kitDescriptionLength = event.value ? event.value.length : 0;
  }

}
